import { baseURL, formatFetchError, getHeader } from '../util'

type ActionResult = {
  _id: string
  post_status_id: number
}

export async function disable(id: string): Promise<ActionResult> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/vehicle/disable?id=${id}`, {
      method: 'PATCH',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

export async function enable(id: string): Promise<ActionResult> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/vehicle/enable?id=${id}`, {
      method: 'PATCH',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
